import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";
import { AppState } from "src/app/reducers";
import { MenuUsuarioService } from "src/app/services/menu-usuario.service";
import { ToastService } from "src/app/services/toast.service";
import { AportePlanSaludInitCancelled, AportePlanSaludInitLoaded, AportePlanSaludInitRequested, CapitaPacienteInitCancelled, CapitaPacienteInitLoaded, CapitaPacienteInitRequested, ComprobanteTesoreriaInitCancelled, ComprobanteTesoreriaInitLoaded, ComprobanteTesoreriaInitRequested, MenuUsuarioActionTypes } from "./menu-usuario.actions";
import { menuUsuarioAlreadyInitialized } from "./menu-usuario.selectors";

@Injectable()
export class MenuUsuarioEffects {

	private readonly NOT_FOUND: number = 404;

	doMenuUsuarioInitRequested$ = createEffect( () => {
		return this.actions$.pipe(
			ofType( MenuUsuarioActionTypes.MenuUsuarioInitRequested ),
			switchMap( () => [ new AportePlanSaludInitRequested(), new ComprobanteTesoreriaInitRequested(), new CapitaPacienteInitRequested() ] )
		);
	});

	doAportePlanSaludInitRequested$ = createEffect( () => {
		return this.actions$.pipe(
			ofType( MenuUsuarioActionTypes.AportePlanSaludInitRequested ),
			withLatestFrom( this.store.select( menuUsuarioAlreadyInitialized ) ),
			switchMap( ([ action, menuUsuarioAlreadyInitialized ]) => {
				return menuUsuarioAlreadyInitialized ? of( null ) :
					this.menuUsuarioService.findYearsAportesPS()
						.pipe(
							catchError( error => {
								if( error instanceof HttpErrorResponse && error.status != this.NOT_FOUND )
									this.toastService.danger( "No se pudo determinar si posee acceso a los aportes al plan de salud" );
								return of( null );
							})
						);
			}),
			map( years => {
				return years == null ? new AportePlanSaludInitCancelled() : new AportePlanSaludInitLoaded( { years } );
			})
		);
	});

	doComprobanteTesoreriaInitRequested$ = createEffect( () => {
		return this.actions$.pipe(
			ofType( MenuUsuarioActionTypes.ComprobanteTesoreriaInitRequested ),
			withLatestFrom( this.store.select( menuUsuarioAlreadyInitialized ) ),
			switchMap( ([ action, menuUsuarioAlreadyInitialized ]) => {
				return menuUsuarioAlreadyInitialized? of( null ):
					this.menuUsuarioService.findProfesionalesAutorizadosIds()
						.pipe(
							catchError( error => {
								if( error instanceof HttpErrorResponse && error.status != this.NOT_FOUND )
									this.toastService.danger( "No se pudo determinar si posee acceso a los comprobantes de tesoreria" );
								return of( null );
							})
						);
			}),
			map( profesionalIds => {
				return profesionalIds == null? new ComprobanteTesoreriaInitCancelled(): new ComprobanteTesoreriaInitLoaded( { profesionalIds } );
			})
		);
	});

	doCapitaPacienteInitRequested$ = createEffect( () => {
		return this.actions$.pipe(
			ofType( MenuUsuarioActionTypes.CapitaPacienteInitRequested ),
			withLatestFrom( this.store.select( menuUsuarioAlreadyInitialized ) ),
			switchMap( ([ action, menuUsuarioAlreadyInitialized ]) => {
				return menuUsuarioAlreadyInitialized? of( null ):
					this.menuUsuarioService.findTotalCapita()
						.pipe(
							catchError( error => {
								if( error instanceof HttpErrorResponse && error.status != this.NOT_FOUND )
									this.toastService.danger( "No se pudo determinar si posee acceso a cápita de pacientes" );
								return of( null );
							})
						);
			}),
			map( totalCapita => {
				return totalCapita == null? new CapitaPacienteInitCancelled(): new CapitaPacienteInitLoaded( { total: totalCapita.total } );
			})
		);
	});


	constructor( private actions$: Actions, private store: Store<AppState>, private menuUsuarioService: MenuUsuarioService, private toastService: ToastService ) {
	}

}

function creatEffect(arg0: () => import("rxjs").Observable<ComprobanteTesoreriaInitRequested | CapitaPacienteInitRequested>) {
	throw new Error("Function not implemented.");
}

